import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Space, Table } from "antd";
import { Box, TextField } from "@mui/material";

const WaTeamRedLava = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editWaTeamRedLavaId, setEditWaTeamRedLavaId] = useState(null);

  const [wateamredlava, setWaTeamRedLava] = useState({
    connectionname: "",
    apiurl: "",
    apikey: "",
    phonenumberid: "",
    whatsappbusinessid: "",
    accesstoken: "",
    businessmanagerid: "",
  });

  const fetchWaTeamRedLavaData = async () => {
    try {
      const response = await axios.get("/api/redlava/getall");
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWaTeamRedLavaData();
  }, []);

  const handleChangeWaTeamRedLava = (e) => {
    const { name, value } = e.target;
    setWaTeamRedLava({
      ...wateamredlava,
      [name]: value,
    });
  };

  const handleAddWaTeamRedLava = (e) => {
    e.preventDefault();

    const wateamredlavaData = {
      ...wateamredlava,
    };
    if (editWaTeamRedLavaId) {
      axios
        .put(`/api/redlava/update/${editWaTeamRedLavaId}`, wateamredlavaData)
        .then((res) => {
          setWaTeamRedLava({
            connectionname: "",
            apiurl: "",
            apikey: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            accesstoken: "",
            businessmanagerid: "",
          });
          Swal.fire({
            title: "WaTeam RedLava Updated successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWaTeamRedLavaData();
          });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Error creating WaTeam RedLava. Please try again.",
            "error"
          );
        });
    } else {
      axios
        .post("/api/redlava/create", wateamredlavaData)
        .then((res) => {
          setWaTeamRedLava({
            connectionname: "",
            apiurl: "",
            apikey: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            accesstoken: "",
            businessmanagerid: "",
          });
          Swal.fire({
            title: "WaTeam RedLava Added successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWaTeamRedLavaData();
          });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Error creating WaTeam RedLava. Please try again.",
            "error"
          );
        });
    }
  };

  const handleDeleteWaTeamRedLava = async (_id) => {
    // Show SweetAlert2 confirm dialog
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      // Show a loading spinner while holding the action
      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .delete(`/api/redlava/delete/${_id}`)
        .then((res) => {
          fetchWaTeamRedLavaData();
          Swal.fire(
            "Deleted!",
            "WaTeam RedLava deleted successfully!",
            "success"
          );
        })
        .catch((error) => {
          Swal.fire("Error", "Something went wrong!", "error");
        });
    }
  };

  const handleEditWaTeamRedLava = (_id) => {
    const selectedWaTeamRedLava = data.find((item) => item._id === _id);

    if (selectedWaTeamRedLava) {
      setEditWaTeamRedLavaId(_id); // Set the ID of the contact being edited
      setWaTeamRedLava({
        connectionname: selectedWaTeamRedLava.connectionname,
        apiurl: selectedWaTeamRedLava.apiurl,
        apikey: selectedWaTeamRedLava.apikey,
        phonenumberid: selectedWaTeamRedLava.phonenumberid,
        whatsappbusinessid: selectedWaTeamRedLava.whatsappbusinessid,
        accesstoken: selectedWaTeamRedLava.accesstoken,
        businessmanagerid: selectedWaTeamRedLava.businessmanagerid,
      }); // Populate the form fields with the selected contact data
    }
    setIsModalOpen(true);
  };

  const handleAddWaTeamRedLavaButton = () => {
    setEditWaTeamRedLavaId(null);
    setWaTeamRedLava({
      connectionname: "",
      apiurl: "",
      apikey: "",
      phonenumberid: "",
      whatsappbusinessid: "",
      accesstoken: "",
      businessmanagerid: "",
    });
  };

  const columns = [
    {
      title: "ID",
      key: "id",
      render: (text, record, index) => index + 1,
      fixed: "left",
      width: 50,
    },

    {
      title: "Connection Name",
      dataIndex: "connectionname",
      key: "connectionname",
      ellipsis: true,
    },
    {
      title: "API URL",
      dataIndex: "apiurl",
      key: "apiurl",
      ellipsis: true,
    },
    {
      title: "API Key",
      dataIndex: "apikey",
      key: "apikey",
      ellipsis: true,
    },
    {
      title: "Phone No. ID",
      dataIndex: "phonenumberid",
      key: "phonenumberid",
      ellipsis: true,
    },
    {
      title: "Whatsapp Business ID",
      dataIndex: "whatsappbusinessid",
      key: "whatsappbusinessid",
      ellipsis: true,
    },
    {
      title: "Business Manager ID",
      dataIndex: "businessmanagerid",
      key: "businessmanagerid",
      ellipsis: true,
    },
    {
      title: "Access Token",
      dataIndex: "accesstoken",
      key: "accesstoken",
      ellipsis: true,
    },

    {
      title: "ACTION",
      key: "action",
      width: 150,

      render: (text, record) => (
        <Space size="middle">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="edit-btn"
            onClick={() => handleEditWaTeamRedLava(record._id)}
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            onClick={() => handleDeleteWaTeamRedLava(record._id)}
            className="delete-btn"
          >
            <i className="ri-delete-bin-fill"></i>
          </button>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Wa-Team RedLava</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2">
                    {/* <!-- Button trigger modal --> */}
                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      onClick={handleAddWaTeamRedLavaButton}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i>
                      Wa-Team RedLava
                    </button>

                    {/* <!-- Modal --> */}
                    <div
                      className="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden={!isModalOpen}
                      // style={{ display: isModalOpen ? "block" : "none" }}
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              {editWaTeamRedLavaId
                                ? "Update Wa-Team RedLava"
                                : "Add Wa-Team RedLava"}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <Box>
                              <TextField
                                color="primary"
                                fullWidth
                                label="Connection Name"
                                name="connectionname"
                                value={wateamredlava.connectionname}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="API URL"
                                name="apiurl"
                                value={wateamredlava.apiurl}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="API Key"
                                name="apikey"
                                value={wateamredlava.apikey}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Phone Number ID"
                                name="phonenumberid"
                                value={wateamredlava.phonenumberid}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Whatsapp Business ID"
                                name="whatsappbusinessid"
                                value={wateamredlava.whatsappbusinessid}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Access Token"
                                name="accesstoken"
                                value={wateamredlava.accesstoken}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Business Manager ID"
                                name="businessmanagerid"
                                value={wateamredlava.businessmanagerid}
                                onChange={handleChangeWaTeamRedLava}
                                margin="normal"
                                required
                                autoFocus
                              />
                            </Box>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={handleAddWaTeamRedLava}
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              {editWaTeamRedLavaId ? "Update" : "Ok"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0"></div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                  <div className="flex-shrink-0">
                    <div className="hstack text-nowrap gap-2 align-item-center"></div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  dataSource={data}
                  columns={columns}
                  rowKey="_id"
                  // scroll={{ x: true }}
                  // style={{ overflowX: data.length > 5 ? "scroll" : "hidden" }} // Show scrollbar only if data is lengthy
                  pagination={{
                    pageSize: 5,
                  }}
                  components={{
                    header: {
                      cell: ({ style, ...restProps }) => (
                        <th
                          {...restProps}
                          style={{
                            ...style,
                            backgroundColor: "#c6c6c6",
                            color: "black",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaTeamRedLava;
